export const ValidationPopupErrorMessage = ({
  errorMessageText,
}: {
  errorMessageText: string;
}) => {
  return (
    <div className="text-[16px] leading-[24px] text-indigo-800 pr-20">
      {errorMessageText}
    </div>
  );
};
